import { useCallback, useEffect, useState } from 'react';
import { NotificationEvent, notificationsService } from '../services/notificationsService';

export const useNotifications = () => {
  const [events, setEvents] = useState<NotificationEvent[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const nextEvents = await notificationsService.getMyNotifications();
      setEvents(nextEvents);
    } catch (refreshError) {
      setError(
        refreshError instanceof Error
          ? refreshError.message
          : 'Failed to load notification feed'
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      return undefined;
    }

    void refresh();
    const interval = setInterval(() => {
      void refresh();
    }, 20000);

    return () => {
      clearInterval(interval);
    };
  }, [refresh]);

  return {
    events,
    loading,
    error,
    refresh,
    pendingCount: events.filter((event) => event.status === 'PENDING').length,
  };
};
